import React, { Fragment, useContext, useEffect, useState } from "react";
import { frFR } from "@material-ui/data-grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import notifyContext from "../Context/notifyContext";
import navContext from "../Context/navContext";
import { findAll } from "../../services/Log__Service";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import Modal from "../Modal/Modal";
import Form from "../Main/Components/USer/Form/Form";

const Log = () => {
  const [viewLogId, setViewLogId] = useState(0);
  const [viewUserId, setViewUserId] = useState(0);
  const [currentLog, setCurrentLog] = useState(null);
  const notify = useContext(notifyContext);
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const nav = useContext(navContext);

  useEffect(() => {
    if (viewLogId !== 0) {
      setCurrentLog(
        logs.find((elt) => {
          return elt.id === viewLogId;
        })
      );
    }
  }, [viewLogId, logs]);

  const columns = React.useMemo(
    () => [
      {
        field: "Description",
        headerName: "Description",
        width: 110,
        flex: 1,
        valueGetter: (params) => {
          return `${params.row.description}`;
        },
      },
      {
        field: "type",
        headerName: "Type",

        width: 100,
        type: "singleSelect",
        valueOptions: ["Création", "Affichage", "Modification", "Suppression"],
        valueGetter: (params) => {
          let value = "";
          const VALUES = [
            "Création",
            "Affichage",
            "Modification",
            "Suppression",
          ];
          value = VALUES[parseInt(params.row.type) - 1];
          return value;
        },
      },
      {
        field: "Nom d'utilisateur",
        headerName: "Nom d'utilisateur",
        flex: 1,
        width: 150,
        flex: 1,
        valueGetter: (params) => {
          return `${params.row.login}`;
        },
        renderCell: (params) => (
          <p
            style={{ cursor: "pointer" }}
            onClick={() => {
              params.row.user_id !== undefined &&
                params.row.user_id !== "" &&
                params.row.user_id !== 0 &&
                setViewUserId(params.row.user_id);
            }}
          >
            {params.value}
          </p>
        ),
      },
      {
        field: "Adresse IP",
        headerName: "Adresse IP",
        width: 150,
        valueGetter: (params) => {
          return `${params.row.ip_address}`;
        },
      },
      {
        field: "Date",
        headerName: "Date",
        type: "Date",
        width: 150,
        valueGetter: (params) => {
          return new Date(params.row.date_create).toLocaleDateString("fr-FR");
        },
      },
      {
        field: "Heure",
        headerName: "Heure",
        type: "Time",
        width: 150,
        valueGetter: (params) => {
          return `${params.row.time_create}`;
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 100,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<MdOutlineRemoveRedEye />}
            label="Voir"
            onClick={() => setViewLogId(params.id)}
            // showInMenu
          />,
        ],
      },
    ],
    []
  );

  useEffect(() => {
    nav({
      links: [
        {
          href: "main/logs/",
          linkname: "Logs",
        },
      ],
      children: "",
    });
    fetchAll();
  }, []);

  const fetchAll = async () => {
    findAll()
      .then((response) => {
        setLogs(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      });
  };
  const handleChangeRowsPerPage = (numberRow) => {
    setRowsPerPage(parseInt(numberRow, 10));
  };

  return (
    <Fragment>
      <div className="log">
        <div className="log__items">
          <div style={{ height: "100%", width: "100%", background: "#fff" }}>
            <DataGrid
              rows={logs}
              columns={columns}
              pageSize={rowsPerPage}
              rowsPerPageOptions={[10, 25, 50, 100]}
              loading={isLoading}
              onPageSizeChange={handleChangeRowsPerPage}
              localeText={frFR.props.MuiDataGrid.localeText}
            />
          </div>
        </div>
      </div>
      {viewLogId !== 0 && (
        <Modal>
          <div className="modal">
            <div
              className="modal__content"
              style={{
                maxWidth: "600px",
              }}
            >
              <div className="modal__header">
                <h2 className="modal__title">Détails du Log</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewLogId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                {currentLog && (
                  <>
                    <div className="log__info">
                      <p className="log__label">Description : </p>
                      <p className="log__text">{currentLog.description}</p>
                    </div>
                    <div className="log__info">
                      <p className="log__label">Login : </p>
                      <p className="log__text">{currentLog.login}</p>
                    </div>
                    <div className="log__info">
                      <p className="log__label">Adresse IP : </p>
                      <p className="log__text">{currentLog.ip_address}</p>
                    </div>
                    <div className="log__info">
                      <p className="log__label">Date : </p>
                      <p className="log__text">
                        {new Date(currentLog.date_create).toLocaleDateString(
                          "fr-FR"
                        )}
                      </p>
                    </div>
                    <div className="log__info">
                      <p className="log__label">Heure : </p>
                      <p className="log__text">{currentLog.time_create}</p>
                    </div>
                  </>
                )}
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewLogId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {viewUserId !== 0 && (
        <Modal>
          <div className="modal">
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails de l'utilisateur</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewUserId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <Form id={viewUserId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewUserId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default Log;
